import { render, staticRenderFns } from "./projectTermBank.vue?vue&type=template&id=4e615e92&scoped=true&"
import script from "./projectTermBank.vue?vue&type=script&lang=js&"
export * from "./projectTermBank.vue?vue&type=script&lang=js&"
import style0 from "./projectTermBank.vue?vue&type=style&index=0&id=4e615e92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e615e92",
  null
  
)

export default component.exports